export default __webpack_public_path__ + "static/media/refuse.38aa7066.svg";